module.exports = __webpack_public_path__ + "092c762051974f534f29c5fdfd168f7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_20.jpg
// module id = 1667
// module chunks = 5